import type { FindFn } from "@shared/models/analytics/base"
import { createBlankEvent } from "@shared/models/analytics/base"
import type { PlanbookCustomizeToggle } from "@shared/models/analytics/planbook"
import type { PreparedAction } from "../../action-doc-builder"
import { partial } from "lodash-es"
import type { Narrative } from "../create-narrative"
import createNarrative from "../create-narrative"
import defaultPlanbookContext from "../planbook/default-planbook-context"
import defaultPlanbookModels from "../planbook/default-planbook-models"

interface Payload {
  planbookId: string
  courseId: string
  isTogglingOn: boolean
}

export default function planbookCourseToggleAction(payload: Payload): PreparedAction {
  return {
    name: "PLANBOOK_COURSE_TOGGLE",
    payload: payload,
    patches: null,
    undoPatches: null,
    narrative: partial(narrative, payload),
  }
}

function narrative(payload: Payload, findFn: FindFn, userId: string): Narrative {
  let titleForAnalytics = payload.isTogglingOn
    ? "Planbook - Course Toggled On"
    : "Planbook - Course Toggled Off"
  let models = defaultPlanbookModels(payload, findFn, userId, payload.planbookId)
  let context = defaultPlanbookContext(payload, models)
  let newEvent: PlanbookCustomizeToggle = {
    ...createBlankEvent(),
    root_id: payload.planbookId,
    root_type: "planbook",
    primary_object_type: "planbook",
    primary_possessive: "owns",
    primary_object_id_and_ancestor_ids: [payload.planbookId],
    primary_verb: "customize",
    primary_object_specifier: "filter_classes",
    adverbial_verb: "toggling",
    adverbial_object_type: "course",
    adverbial_object_specifier: payload.isTogglingOn ? "on" : "off",
  }

  return createNarrative({
    titleForAnalytics: titleForAnalytics,
    context: context,
    newAnalyticsEvents: [newEvent],
  })
}
